import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import Select from 'react-select';
import './AdminModals.css';
const API_URL = process.env.REACT_APP_API_URL;

const EditDiscountModal = ({ isOpen, onClose, onSave, discount }) => {
  const { t } = useTranslation();
  const { token } = useAuth();
  
  const [formData, setFormData] = useState({
    code: '', description: '', type: 'event', value: '', value_type: 'percent',
    user_id: null, start_date: '', end_date: '', is_active: true,
	usage_limit: ''
  });
  const [users, setUsers] = useState([]);
  const [error, setError] = useState('');
  const [loadingUsers, setLoadingUsers] = useState(false);

  // DÜZELTME: Tüm başlangıç mantığı tek bir useEffect'de birleştirildi.
  useEffect(() => {
    // 1. Eğer bir 'discount' prop'u varsa (yani düzenleme moduysa), formu doldur.
    if (discount) {
      setFormData({
        code: discount.code || '',
        description: discount.description || '',
        type: discount.type || 'event',
        value: discount.value || '',
        value_type: discount.value_type || 'percent',
        user_id: discount.user_id || null,
        start_date: discount.start_date ? new Date(discount.start_date).toISOString().slice(0, 10) : '',
        end_date: discount.end_date ? new Date(discount.end_date).toISOString().slice(0, 10) : '',
        is_active: discount.is_active !== undefined ? discount.is_active : true,
		usage_limit: discount.usage_limit || '' // `null` ise boş string yap
      });
    } else {
        // Eğer 'discount' prop'u yoksa (yeni ekleme moduysa), formu sıfırla.
        setFormData({
            code: '', description: '', type: 'event', value: '', value_type: 'percent',
            user_id: null, start_date: '', end_date: '', is_active: true,
			usage_limit: ''
        });
    }

    // 2. Kullanıcı listesini her zaman çek, çünkü başka bir yerde de gerekebilir.
    // Bu, performansı etkilemez çünkü liste state'te saklanır ve sadece bir kere çekilir.
if (token && users.length === 0) {
            setLoadingUsers(true);
            fetch(`${API_URL}/api/admin/users`, { headers: { 'Authorization': `Bearer ${token}` } })
                .then(res => res.json())
                .then(data => {
                    // DÜZELTME: Gelen her kullanıcı verisini saklayacak şekilde map'le
                    const userOptions = data.map(u => ({
                        value: u.id,
                        label: `${u.first_name} ${u.last_name}`, // Label'da sadece isim soyisim olsun
                        // Arama için ekstra verileri buraya ekle
                        email: u.email,
                        phone: `${u.phone_country_code || ''}${u.phone_number || ''}`
                    }));
                    setUsers(userOptions);
                })
                .catch(err => console.error("Kullanıcı listesi alınamadı:", err))
                .finally(() => setLoadingUsers(false));
        }
    }, [discount, token, users.length]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleUserSelect = (selectedOption) => {
    setFormData(prev => ({ ...prev, user_id: selectedOption ? selectedOption.value : null }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const dataToSend = {
      ...formData,
      usage_limit: formData.usage_limit === '' ? null : Number(formData.usage_limit)
    };
    const url = discount 
      ? `${API_URL}/api/admin/discounts/${discount.id}` 
      : `${API_URL}/api/admin/discounts`;
    
    const method = discount ? 'PUT' : 'POST';

    try {
      const response = await fetch(url, {
        method: method,
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(dataToSend) // dataToSend'i gönder
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(t(data.messageKey) || 'İşlem başarısız oldu.');
      }
      onSave(); // Ana bileşene kaydetme işleminin başarılı olduğunu bildir
    } catch (err) {
      setError(err.message);
    }
  };
  
  // YENİ: react-select için özel filtreleme fonksiyonu
    const customFilter = (option, inputValue) => {
        if (inputValue === '') return true; // Yazı yoksa her şeyi göster
        const searchTerm = inputValue.toLowerCase();

        // option.label (isim), option.email veya option.phone içinde arama yap
        return (
            option.label.toLowerCase().includes(searchTerm) ||
            (option.data.email && option.data.email.toLowerCase().includes(searchTerm)) ||
            (option.data.phone && option.data.phone.toLowerCase().includes(searchTerm))
        );
    };


    if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="admin-modal-overlay" onClick={onClose}>
      <div className="admin-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal-header">
          <h3>{discount ? t('edit_discount') : t('add_new_discount')}</h3>
          <button onClick={onClose} className="close-btn">&times;</button>
        </div>
        <form onSubmit={handleSubmit} className="admin-modal-form">
            <div className="form-group-auth">
                <label>{t('description')}</label>
                <input name="description" value={formData.description} onChange={handleChange} required />
            </div>
            <div className="form-group-auth">
                <label>{t('code')} ({t('optional')})</label>
                <input name="code" value={formData.code} onChange={handleChange} />
            </div>
            <div className="form-row-auth">
                <div className="form-group-auth half-width">
                    <label>{t('type')}</label>
                    <select name="type" value={formData.type} onChange={handleChange}>
                        <option value="event">{t('discount_type_event')}</option>
                        <option value="user_specific">{t('discount_type_user_specific')}</option>
                        <option value="first_order">{t('discount_type_first_order')}</option>
                    </select>
                </div>
                {formData.type === 'user_specific' && (
                    <div className="form-group-auth half-width">
                        <label>{t('customer')}</label>
                        <Select 
                                options={users} 
                                isClearable 
                                // DÜZELTME: Seçili değeri doğru bul
                                value={users.find(u => u.value === formData.user_id)}
                                onChange={handleUserSelect}
                                // YENİ: Özel filtreleme ve placeholder ekle
                                filterOption={customFilter}
                                placeholder={t('search_customer_placeholder', 'İsim, e-posta veya telefon ile arayın...')}
                                noOptionsMessage={() => t('no_users_found', 'Kullanıcı bulunamadı')}
                                isLoading={loadingUsers}
                            />
                        </div>
                    )}
            </div>
            <div className="form-row-auth">
                <div className="form-group-auth half-width">
                    <label>{t('value')}</label>
                    <input name="value" type="number" step="0.01" value={formData.value} onChange={handleChange} required />
                </div>
                <div className="form-group-auth half-width">
                    <label>{t('value_type')}</label>
                    <select name="value_type" value={formData.value_type} onChange={handleChange}>
                        <option value="percent">{t('percent')}</option>
                        <option value="fixed">{t('fixed_amount')}</option>
                    </select>
                </div>
            </div>
			 <div className="form-group-auth">
                <label>{t('usage_limit')} ({t('usage_limit_info')})</label>
                <input 
                    name="usage_limit" 
                    type="number" 
                    min="0"
                    placeholder={t('unlimited')}
                    value={formData.usage_limit} 
                    onChange={handleChange} 
                />
            </div>
             <div className="form-row-auth">
                <div className="form-group-auth half-width">
                    <label>{t('start_date')} ({t('optional')})</label>
                    <input name="start_date" type="date" value={formData.start_date} onChange={handleChange} />
                </div>
                <div className="form-group-auth half-width">
                    <label>{t('end_date')} ({t('optional')})</label>
                    <input name="end_date" type="date" value={formData.end_date} onChange={handleChange} />
                </div>
            </div>
        <div className="form-group-auth">
    <label className="auth-checkbox">
        <input 
            name="is_active" 
            type="checkbox" 
            checked={formData.is_active} 
            onChange={handleChange} 
        />
        <div className="switch-track">
            <div className="switch-thumb"></div>
        </div>
        <span>{t('active')}</span>
    </label>
</div>
            {error && <p className="auth-error">{error}</p>}
            <div className="admin-modal-footer">
                <button type="button" onClick={onClose} className="btn-secondary">{t('cancel')}</button>
                <button type="submit" className="btn-primary">{t('save')}</button>
            </div>
        </form>
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};
export default EditDiscountModal;